import React from 'react'
import { Link } from 'react-router'
import { Content } from 'components'
import { Spinner } from 'lp-components'
import { MARKETING_LIBRARY_DOCUMENT_TITLE } from 'config'
import { useDocumentTitle } from 'utils'

function VirtualLearningLibrary() {
  useDocumentTitle(MARKETING_LIBRARY_DOCUMENT_TITLE)

  return (
    <Content className="iframe-content">
      <nav className="home-navigation" aria-label="Page">
        <ul>
          <li>
            <Link to="/">artlook Map home</Link>
          </li>
        </ul>
      </nav>
      <Spinner />
      <iframe
        title="Virtual & Online Programs"
        src="https://ingenuity-dataviz.shinyapps.io/virtual_programs/"
        width="100%"
        height="100%"
        className="full-iframe"
      ></iframe>
    </Content>
  )
}

export default VirtualLearningLibrary
